import { LinkStatus } from '@/features/regulatory-intake/enums';

import {
  getLinkStatusIcon,
  getLinkStatusLabel,
} from '@/features/regulatory-intake/intake-details/utils';

export const LINK_STATUSES = [
  {
    label: getLinkStatusLabel(LinkStatus.Resolved),
    icon: getLinkStatusIcon(LinkStatus.Resolved),
  },
  {
    label: getLinkStatusLabel(LinkStatus.Pending),
    icon: getLinkStatusIcon(LinkStatus.Pending),
  },
  {
    label: getLinkStatusLabel(LinkStatus.CaptchaCheck),
    icon: getLinkStatusIcon(LinkStatus.CaptchaCheck),
  },
  {
    label: getLinkStatusLabel(LinkStatus.Attention),
    icon: getLinkStatusIcon(LinkStatus.Attention),
  },
];
